import { MathResult } from "@/financeModels/types";
import { evaluteWithErrors, isNumber, toNumberOrNull } from "./math";

export const percentInputToNumber = (value: string | number) => {
  if (value === "") return null;
  const number = evaluteWithErrors<number>("val / 100", { val: Number(value) });

  return toNumberOrNull(number);
};

export const numberToPercentInput = (value: MathResult) => {
  if (value === null) return "";

  const percent = toNumberOrNull(
    evaluteWithErrors<number>("val * 100", { val: value }),
  );

  return percent === null ? "" : percent;
};

export const formatDecimalPercent = (
  value: MathResult,
  fractionDigits: number = 2,
) => {
  if (!isNumber(value)) return "";
  return `${(value * 100).toFixed(fractionDigits).replace(/\.?0+$/, "")}%`;
};

export const formatDecimalPercentTwoPlaces = (
  value: MathResult,
  fractionDigits: number = 2,
) => {
  if (!isNumber(value)) return "";
  return `${(value * 100).toFixed(fractionDigits)}%`.replace("-0.00%", "0.00%");
};
